import React from 'react';
import PropTypes from 'prop-types';
import Typography from '../Typography';
import { StyledPlace, StyledTypographyWrapper } from './styled';
import Image from '../Image';
import { getImageUrl } from '../../utils/helpers';

const Place = ({ name, address, logo, typographyCmp }) => {
    return (
        <StyledPlace>
            {
                logo &&
                <Image
                    alt={name}
                    src={getImageUrl(logo?.url)}
                    maxWidth="30px"
                />
            }
            <StyledTypographyWrapper>
                {
                    name &&
                    <Typography component={typographyCmp}>
                        {name}
                    </Typography>
                }
                {
                    address &&
                    <Typography component={typographyCmp}>
                        {address}
                    </Typography>
                }
            </StyledTypographyWrapper>
        </StyledPlace>
    );
};

Place.propTypes = {
    name: PropTypes.string,
    address: PropTypes.string,
    logo: PropTypes.object,
    typographyCmp: PropTypes.string
};

Place.defaultProps = {
    typographyCmp: "h2"
};

export default React.memo(Place);
